import * as gfunctions from '../../../js/generalFunctions';

CCL.removalCartModal = {
  autoload: [
    ['modalEvents', $('#removalCartModal').length > 0]
  ],

  modalEvents() {
    const modalEl = $('#removalCartModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-removal-cart-modal/removal-cart-modal.js